export const codeValidationMessage = 'Only Alphanumeric and underscores are allowed';
export const backButtonText = 'Back to search';
export const nameValidationMessage = 'Only alphabets, numbers are allowed';
export const startingWhiteSpaceValidation = 'White spaces are not allowed';
export const codeWithSpecialCharacter = 'Only Alphanumeric and () - _  are allowed';
export const modulesText = 'Used In';
export const onlyNumberAllow = 'Accepts Digits';
export const downloadButton = 'View & Download Configuration';
export const backToBatches = 'Back to Batches';
export const nameWithSpecialCharacter ='Please use only the English letters (A-Z, a-z), numerals (0-9), ., -,_,\', comma and spaces';
export const ACCOUNT_STATUS = "Account Status";
export const IMPORTANT_NOTES = "Important Notes";
export const ACCOUNT_GUARANTOR = "Account Guarantor";
export const PATIENT_DEMOGRAPHICS = "Patient / Customer Demographics";
export const PATIENT_CUSTOMER_INFORMATION = "Patient / Customer Information";
export const SPOUSE_INFORMATION = "Spouse Information";
export const POE_INFORMATION = "POE Information";
export const COMMUNICATION_OPT_OUTS = "Communication Opt Outs";